import { Menu } from "antd"
import Link from "next/link"
import { useAuth } from "../../../contexts/auth"
import {
  DollarCircleOutlined,
  EyeOutlined,
  InboxOutlined,
  TeamOutlined
} from "@ant-design/icons"
import PropTypes from "prop-types"
import ConfidentialityDisclaimer from "./confidentiality-disclaimer"

AdminMenu.propTypes = {
  step: PropTypes.any,
  submenu: PropTypes.any
}

export default function AdminMenu({ step, submenu }) {
  const { user } = useAuth() || {}

  const permissions = ["ADMIN","ADMIN_BASIC","ADMIN_TECHNICAL_AND_FINANCIAL","ADMIN_EVALUATOR", "ADMIN_ASSISTANT"]

  return (
    <>
      <Menu
        defaultSelectedKeys={[step]}
        defaultOpenKeys={[submenu]}
        theme="dark"
        className="fico main-menu"
        mode="inline">
        <Menu.SubMenu
          key="submissions"
          icon={<InboxOutlined />}
          title="Solicitudes">
          <Menu.Item key="SUBMISSIONS_RESUME">
            <Link href={"/dashboards/submissions"}>
              Resumen de solicitudes por aprobar
            </Link>
          </Menu.Item>
          <Menu.Item key="submissions">
            <Link href="/admin/submissions">
              Todas las solicitudes
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_LOCAL_COUNCIL">
            <Link href="/admin/submissions/status/on_local_council">
              Consejo Local
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_COUNCIL">
            <Link href="/admin/submissions/status/on_council">
              Consejo directivo
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_COMMITTEE">
            <Link href="/admin/submissions/status/on_committee">
              Comité técnico
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_AGREEMENT">
            <Link href="/admin/submissions/status/on_agreement">
              Convenio
            </Link>
          </Menu.Item>
          <Menu.Item key="REJECTED">
            <Link href="/admin/submissions/status/rejected">
              Rechazadas
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          key="projects"
          icon={<EyeOutlined />}
          title="Monitoreo de proyectos">
          <Menu.Item key="MONITORIN_RESUME">
            <Link href={"/dashboards/monitoring"}>
              Resumen de monitoreo
            </Link>
          </Menu.Item>
          <Menu.Item key="PROJECTS_RESUME">
            <Link href={"/dashboards/projects"}>
              Resumen de proyectos aprobados
            </Link>
          </Menu.Item>
          <Menu.Item key="active">
            <Link href="/admin/projects">
              Activos
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_CLOSURE">
            <Link href="/admin/projects/status/on_closure">
              Concluidos
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        {permissions.includes(user?.claims?.role) && (
          <Menu.Item key="users">
            <TeamOutlined />
            &nbsp; &nbsp;
            <Link href="/admin/users">
              Usuarios
            </Link>
          </Menu.Item>
        )}
        {(user?.claims?.role === "ADMIN" || user?.claims?.role === "ADMIN_EVALUATOR" || user?.claims?.role === "ADMIN_BASIC") && (
          <Menu.Item key="census">
            <TeamOutlined />
            &nbsp; &nbsp;
            <Link href="/admin/census">
              Padrón de beneficiarios
            </Link>
          </Menu.Item>
        )}
        <Menu.Item icon={<InboxOutlined />} key="PAYMENTS_DETAILS">
          <Link href={"/admin/projects/payments-details"}>
            Pagos
          </Link>
        </Menu.Item>
        <Menu.Item icon={<TeamOutlined />} key="RRHH_DETAILS">
          <Link href={"/admin/projects/rrhh"}>
            Registro de RRHH 
          </Link>
        </Menu.Item>
        <Menu.Item icon={<DollarCircleOutlined />} key="BUDGET_AVAILABILITY">
          <Link href={"/admin/budget-availability"}>
            Disponibilidad presupuestal
          </Link>
        </Menu.Item>
      </Menu>
      <ConfidentialityDisclaimer />
    </>
  )
}
